<template>
  <div>
    <p class="amount--label text-uppercase"><slot></slot></p>
    <p class="amount--value">{{ value }}</p>
  </div>
</template>

<script>
export default {
  name: "SummaryItem",
  props: {
    amount: {
      type: Number,
      default: 0
    },
  },
  computed: {
    value() {
      if(this.amount) {
        return this.$utils.formatCurrency(this.amount);
      } else {
        return '--'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.amount {

  &--label {
    margin: 8px 0 4px;
    font-size: 0.75rem;
    color: $text-light;
    line-height: 1.2;
  }

  &--value {
    font-size: 1.25rem;
    color: $primary;
  }
}
</style>
